var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { client as braintreeClient, paypalCheckout, dataCollector, } from "braintree-web";
import { usePayment } from "../../app/usePayment";
import { useNotifications } from "../../app/useNotifications";
import { useLoader } from "../../app/useLoader";
import { HOSTED_FIELDS_LABEL, renderMaskButtonClasses } from "../../styles";
var FUNDING_SOURCES = ["paypal"];
export var PayPalMask = function (_a) {
    var flow = _a.flow, buttonLabel = _a.buttonLabel, buttonColor = _a.buttonColor, payLater = _a.payLater, payLaterButtonColor = _a.payLaterButtonColor, locale = _a.locale, intent = _a.intent, commit = _a.commit, enableShippingAddress = _a.enableShippingAddress, billingAgreementDescription = _a.billingAgreementDescription, shippingAddressEditable = _a.shippingAddressEditable, shippingAddressOverride = _a.shippingAddressOverride, fullWidth = _a.fullWidth, buttonText = _a.buttonText, useKount = _a.useKount, lineItems = _a.lineItems, shipping = _a.shipping, shape = _a.shape, size = _a.size, tagline = _a.tagline, height = _a.height, shippingOptions = _a.shippingOptions, _b = _a.isPureVault, isPureVault = _b === void 0 ? false : _b;
    var _c = useState([]), limitedVaultedPayments = _c[0], setLimitedVaultedPaymentMethods = _c[1];
    var _d = useState(""), selectedAccount = _d[0], setSelectedAccount = _d[1];
    var _e = useState(""), deviceData = _e[0], setDeviceData = _e[1];
    var _f = usePayment(), handlePurchase = _f.handlePurchase, paymentInfo = _f.paymentInfo, clientToken = _f.clientToken, handlePureVault = _f.handlePureVault, handleGetVaultedPaymentMethods = _f.handleGetVaultedPaymentMethods;
    var notify = useNotifications().notify;
    var isLoading = useLoader().isLoading;
    useEffect(function () {
        if (isPureVault) {
            return;
        }
        var filteredPaymentMethods = [];
        handleGetVaultedPaymentMethods().then(function (paymentMethods) {
            paymentMethods.forEach(function (paymentMethod) {
                if (paymentMethod.type === "PayPalAccount") {
                    filteredPaymentMethods.push({
                        nonce: paymentMethod.nonce,
                        details: paymentMethod.details,
                    });
                }
            });
            setLimitedVaultedPaymentMethods(filteredPaymentMethods);
        });
    }, [clientToken]);
    useEffect(function () {
        isLoading(true);
        var isVault = flow === "vault";
        var additionalFundingSources = {};
        if (payLater) {
            additionalFundingSources["paylater"] = {
                buttonColor: payLaterButtonColor,
            };
        }
        var additionalFundingMethods = Object.keys(additionalFundingSources !== null && additionalFundingSources !== void 0 ? additionalFundingSources : {});
        additionalFundingMethods.map(function (additionalFundingMethod) {
            if (!FUNDING_SOURCES.includes(additionalFundingMethod)) {
                FUNDING_SOURCES.push(additionalFundingMethod);
            }
        });
        var enableFunding = additionalFundingMethods.length
            ? {
                "enable-funding": additionalFundingMethods.toString(),
            }
            : {};
        var fundingButtonConfigs = __assign({ paypal: {
                buttonColor: buttonColor,
                buttonLabel: buttonLabel,
            } }, (additionalFundingSources !== null && additionalFundingSources !== void 0 ? additionalFundingSources : {}));
        braintreeClient.create({
            authorization: clientToken,
        }, function (clientErr, clientInstance) {
            if (clientErr) {
                isLoading(false);
                notify("Error", "Error creating client.");
                return;
            }
            dataCollector.create({
                client: clientInstance,
                paypal: true,
                kount: useKount !== null && useKount !== void 0 ? useKount : undefined,
            }, function (dataCollectorErr, dataCollectorInstance) {
                if (!dataCollectorErr && dataCollectorInstance) {
                    setDeviceData(dataCollectorInstance.deviceData);
                }
            });
            paypalCheckout.create({
                client: clientInstance,
            }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                if (paypalCheckoutErr) {
                    isLoading(false);
                    notify("Error", "Error in paypal checkout.");
                    return;
                }
                paypalCheckoutInstance.loadPayPalSDK(isVault
                    ? { vault: true }
                    : __assign({ currency: paymentInfo.currency, intent: intent }, enableFunding), function () {
                    var paypal = global.paypal;
                    var handleOnApprove = function (data, actions) {
                        return paypalCheckoutInstance.tokenizePayment(data, function (err, payload) {
                            if (isPureVault) {
                                handlePureVault(payload.nonce);
                            }
                            else {
                                handlePurchase(payload.nonce, {
                                    deviceData: deviceData,
                                    lineItems: lineItems,
                                    shipping: shipping,
                                    account: {
                                        email: payload.details.email,
                                    },
                                    billing: {
                                        firstName: payload.details.firstName,
                                        lastName: payload.details.lastName,
                                        streetName: payload.details.shippingAddress.line1,
                                        streetNumber: payload.details.shippingAddress.line1,
                                        city: payload.details.shippingAddress.city,
                                        country: payload.details.countryCode,
                                        postalCode: payload.details.shippingAddress.postalCode,
                                    },
                                });
                            }
                        });
                    };
                    var handleOnClose = function (data) {
                        notify("Info", "PayPal payment cancelled.");
                    };
                    var handleOnError = function (err) {
                        notify("Info", "PayPal payment cancelled.");
                    };
                    if (isVault) {
                        paypal
                            .Buttons({
                            style: {
                                label: buttonLabel,
                                color: buttonColor,
                                shape: shape,
                                size: size,
                                tagline: tagline,
                                height: height,
                            },
                            fundingSource: "paypal",
                            createBillingAgreement: function () {
                                return paypalCheckoutInstance.createPayment({
                                    flow: flow,
                                    billingAgreementDescription: billingAgreementDescription,
                                    enableShippingAddress: enableShippingAddress,
                                    shippingAddressEditable: shippingAddressEditable,
                                    shippingAddressOverride: shippingAddressOverride,
                                });
                            },
                            onApprove: handleOnApprove,
                            onCancel: handleOnClose,
                            onError: handleOnError,
                        })
                            .render("#paypal-button");
                    }
                    else {
                        FUNDING_SOURCES.forEach(function (fundingSource) {
                            paypal
                                .Buttons({
                                style: {
                                    label: fundingButtonConfigs[fundingSource].buttonLabel,
                                    color: fundingButtonConfigs[fundingSource].buttonColor,
                                    shape: shape,
                                    size: size,
                                    tagline: tagline,
                                    height: height,
                                },
                                fundingSource: fundingSource,
                                onShippingChange: function (data, actions) {
                                    if (!shippingOptions)
                                        return;
                                    var countryCode = data.shipping_address.country_code;
                                    if (!countryCode)
                                        return actions.reject();
                                    var shippingOption = shippingOptions.find(function (shippingOption) {
                                        return shippingOption.countryCode === countryCode;
                                    });
                                    if (shippingOption) {
                                        if (lineItems) {
                                            var shippingLineItemIndex = lineItems === null || lineItems === void 0 ? void 0 : lineItems.findIndex(function (lineItem) { return lineItem.name === "Shipping"; });
                                            var shippingAmountString = shippingOption.amount.toString();
                                            if (shippingLineItemIndex &&
                                                shippingLineItemIndex > -1) {
                                                lineItems[shippingLineItemIndex].unitAmount =
                                                    shippingAmountString;
                                                lineItems[shippingLineItemIndex].totalAmount =
                                                    shippingAmountString;
                                            }
                                            else {
                                                lineItems.push({
                                                    name: "Shipping",
                                                    kind: "debit",
                                                    quantity: "1",
                                                    totalAmount: shippingAmountString,
                                                    unitAmount: shippingAmountString,
                                                });
                                            }
                                        }
                                        return paypalCheckoutInstance.updatePayment({
                                            amount: paymentInfo.amount + shippingOption.amount,
                                            currency: paymentInfo.currency,
                                            lineItems: lineItems,
                                            paymentId: data.paymentId,
                                        });
                                    }
                                    else {
                                        return actions.reject();
                                    }
                                },
                                createOrder: function () {
                                    return paypalCheckoutInstance.createPayment({
                                        flow: flow,
                                        locale: locale,
                                        amount: paymentInfo.amount,
                                        currency: paymentInfo.currency,
                                        intent: intent,
                                        commit: commit,
                                        enableShippingAddress: enableShippingAddress,
                                        shippingAddressEditable: shippingAddressEditable,
                                        paypalLineItem: lineItems,
                                        billingAgreementDescription: billingAgreementDescription,
                                        shippingAddressOverride: shippingAddressOverride,
                                    });
                                },
                                onApprove: handleOnApprove,
                                onCancel: handleOnClose,
                                onError: handleOnError,
                            })
                                .render("#paypal-button");
                        });
                    }
                    isLoading(false);
                });
            });
        });
    }, [
        paymentInfo,
        clientToken,
        buttonColor,
        buttonLabel,
        flow,
        payLater,
        payLaterButtonColor,
        commit,
        enableShippingAddress,
        intent,
        isLoading,
        locale,
        lineItems,
        billingAgreementDescription,
        shippingAddressEditable,
        shippingAddressOverride,
        shape,
        size,
        tagline,
        height,
    ]);
    var changeAccount = function (e) {
        var value = e.target.value;
        setSelectedAccount(value);
    };
    var handleVaultedPurchase = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isLoading(true);
                    return [4 /*yield*/, handlePurchase(selectedAccount, {
                            deviceData: deviceData,
                            lineItems: lineItems,
                            shipping: shipping,
                        })];
                case 1:
                    _a.sent();
                    isLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [!!limitedVaultedPayments.length && (_jsx("div", __assign({ className: "block w-full" }, { children: limitedVaultedPayments.map(function (vaultedMethod, index) {
                    return (_jsxs("div", __assign({ className: "flex gap-x-5 justify-start content-center border p-2 border-gray-300 rounded my-4" }, { children: [_jsx("input", { className: "w-3 justify-self-center", id: "credit-card-".concat(index), type: "radio", name: "select-credit-card", value: vaultedMethod.nonce, onChange: changeAccount }), _jsx("label", __assign({ htmlFor: "credit-card-".concat(index), className: "cursor-pointer w-full" }, { children: _jsx("span", __assign({ className: HOSTED_FIELDS_LABEL }, { children: vaultedMethod.details.email })) }))] }), index));
                }) }))), selectedAccount !== "" && (_jsx("div", { children: _jsx("button", __assign({ onClick: handleVaultedPurchase, className: "".concat(renderMaskButtonClasses(fullWidth !== null && fullWidth !== void 0 ? fullWidth : false, true, false), " mb-5") }, { children: buttonText })) })), selectedAccount === "" && _jsx("div", { id: "paypal-button" })] }));
};
